import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { WarehouseNewPage } from '@/features/references/warehouses/pages/warehouse-new-page'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/references/warehouses/new')({
  beforeLoad: requireAuth,
  loader: ({ context }) => {
    const qc = context.queryClient
    return Promise.all([
      qc.ensureQueryData(projectsListQuery()),
      qc.ensureQueryData(usersListQuery()),
    ])
  },
  component: WarehouseNewPage,
  staticData: { crumb: messages.crumbs.refWarehouseNew },
})
